import { Component, OnInit, ViewChild } from '@angular/core';
import { AddressBookSearchResult, AddressbookService } from 'src/app/services/addressbook.service';

@Component({
  selector: 'app-addressbook',
  templateUrl: './addressbook.component.html',
  styleUrls: ['./addressbook.component.scss']
})
export class AddressbookComponent implements OnInit {

  addressbooksearchvalue: string;
  addressbookresults: AddressBookSearchResult[];

  @ViewChild('dropdown') dropdown;

  constructor(public addressbook: AddressbookService) { }

  ngOnInit(): void {
  }

  searchAddressBook(event) {
    // Open address book dialog
    this.addressbook.search(this.addressbooksearchvalue)
      .subscribe(addresses => {
          this.addressbookresults = addresses;
          this.dropdown.toggle(true);
      });
  }

  newAddressBook() {

  }
}
